import * as React from 'react'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AgentLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  task: IJsonResponse
}

const FIELDS = {
  id: 'id',
  name: 'name',
  label: 'label',
  position: 'position',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('task', { scope: 'activerecord.models' }),
})

const AgenttasksEdit: React.FC<IProps> = props => {
  const { data } = agentService.getDataFromJson(props.task)
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { updatedTask, flush } = await agentService.updateTask(values.id, values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/agent/tasks'
  }, [])

  return (
    <AgentLayoutEdit
      model="tasks"
      title={title}
      fields={FIELDS}
      indexLink="/agent/tasks"
      formItems={
        <>
          <InputText
            readonly={true}
            name="id"
            defaultValue={data.id}
            label={I18n.t('generic.id')}
          />
          <InputText
            required={true}
            name="name"
            defaultValue={data.name}
            label={I18n.t('generic.name')}
          />
          <InputText
            required={true}
            name="label"
            defaultValue={data.label}
            label={I18n.t('generic.label')}
            placeholder="メ、ホ、他、などの省略表記"
          />
          <InputText
            required={true}
            name="position"
            defaultValue={data.position}
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AgenttasksEdit
